const dataEl = document.querySelector('.slideshow-splide');
if (dataEl?.dataset.id) {
  let splide = new Splide(`.splide-${dataEl.dataset.id}`);
  // on ready
  splide.on('ready', function () {
    if (splide.root.classList.contains('splide--hidden')) splide.root.classList.remove('splide--hidden');
    // splide horizontal scroll
    // https://github.com/Splidejs/splide/discussions/1094#discussioncomment-6000449
    let ticking = false;
    splide.root.parentNode.addEventListener('wheel', (e) => {
      if (!ticking) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          return;
        }
        if (e.deltaX > 10) {
          splide.go('+1');
        } else if (e.deltaX < -10) {
          splide.go('-1');
        }
        setTimeout(() => {
          ticking = false;
        }, splide.options.speed);
        ticking = true;
      }
    });
  });
  // init splide
  splide.mount();

  // theme editor
  if (window.Shopify.designMode && splide) {
    // reinit splide on section changes
    document.addEventListener('shopify:section:load', (event) => {
      if (dataEl?.dataset.id) {
        splide = new Splide(`.splide-${dataEl.dataset.id}`);
        // on ready
        splide.on('ready', function () {
          if (splide.root.classList.contains('splide--hidden')) splide.root.classList.remove('splide--hidden');
          let ticking = false;
          splide.root.parentNode.addEventListener('wheel', (e) => {
            if (!ticking) {
              if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                return;
              }
              if (e.deltaX > 10) {
                splide.go('+1');
              } else if (e.deltaX < -10) {
                splide.go('-1');
              }
              setTimeout(() => {
                ticking = false;
              }, splide.options.speed);
              ticking = true;
            }
          });
        });
        // init splide
        splide.mount();
      }
    });

    // change slide and pause autoplay on block select
    document.addEventListener('shopify:block:select', (event) => {
      const index = parseInt(event.target.dataset.index);
      if (typeof index === 'number' && splide) {
        splide.go(index);
        splide.Components.Autoplay.pause();
      }
    });

    // resume autoplay on block deselect
    document.addEventListener('shopify:block:deselect', (event) => {
      if (splide && splide.Components.Autoplay.isPaused()) {
        splide.Components.Autoplay.play();
      }
    });
  }
}
